import f from "./_asciiWords.js";
import m from "./_hasUnicodeWord.js";
import i from "./toString.js";
import e from "./_unicodeWords.js";
function a(o, d, r) {
  return o = i(o), d = r ? void 0 : d, d === void 0 ? m(o) ? e(o) : f(o) : o.match(d) || [];
}
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/words.js
// module id = 1577
// module chunks = 67